<template>
    <v-container id="DetalleReporte" class="pt-5">
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-layout row wrap>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color:transparent !important;" width="100%" id="DatosGenerales">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Datos Generales </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon :color="'#FFFFFF'">mdi-file-document</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Número de averiguación Previa: "
                                    :subtitle="this.detalleReporteData.svnumave"></vs-list-item>
                                <vs-list-item title="Número de Póliza:"
                                    :subtitle="this.detalleReporteData.dapoliza"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Número de Siniestro:"
                                    :subtitle="this.detalleReporteData.svnumsin"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Inciso:" :subtitle="this.detalleReporteData.dainciso"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Estado:" :subtitle="this.detalleReporteData.esnombre"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Localidad:"
                                    :subtitle="this.detalleReporteData.lonombre"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Aseguradora:"
                                    :subtitle="this.detalleReporteData.clnombre"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Flotilla:"
                                    :subtitle="this.detalleReporteData.flnomcorto"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Asegurado:"
                                    :subtitle="this.detalleReporteData.asnombre"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Conductor:"
                                    :subtitle="this.detalleReporteData.svnomcond"></vs-list-item>
                            </vs-list>

                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Otros Datos</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon :color="'#FFFFFF'">mdi-account-supervisor</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Ajustador:"
                                    :subtitle="this.detalleReporteData.svajustador"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Proveedor:"
                                    :subtitle="this.detalleReporteData.prnombre"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Presentaciónn:"
                                    :subtitle="this.detalleReporteData.ptdesc"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Comentarios:"
                                    :subtitle="this.detalleReporteData.svconversa"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color:transparent !important;" width="100%">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Asistencia</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon :color="'#FFFFFF'">mdi-information-outline</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item :subtitle="this.detalleReporteData.ainombre"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Datos del Vehiculo </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon :color="'#FFFFFF'">mdi-car-info</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Serie: " :subtitle="this.detalleReporteData.svserie"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Marca: " :subtitle="this.detalleReporteData.svmarca"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Modelo: " :subtitle="this.detalleReporteData.svmodelo"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Año: " :subtitle="this.detalleReporteData.svanio"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Color: " :subtitle="this.detalleReporteData.svcolor"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Placas: " :subtitle="this.detalleReporteData.svplaca"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <Telefonos></Telefonos>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color:transparent !important;" width="100%">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Ubicaciones</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon :color="'#FFFFFF'">mdi-map-marker-radius</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Origen:" :subtitle="this.detalleReporteData.lonombre"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Destino:" :subtitle="this.detalleReporteData.destino"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Fechas</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon :color="'#FFFFFF'">mdi-calendar</v-icon>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Fecha y hora del siniestro:"
                                    :subtitle="this.detalleReporteData.svfhsiniestro"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Fecha y hora del reporte:"
                                    :subtitle="this.detalleReporteData.svfhreporte"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Fecha y hora estimada:"
                                    :subtitle="this.detalleReporteData.svfhestimada"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Fecha y hora de contacto:"
                                    :subtitle="this.detalleReporteData.svfhcontacto"></vs-list-item>
                            </vs-list>
                            <vs-list>
                                <vs-list-item title="Fecha y hora del termino:"
                                    :subtitle="this.detalleReporteData.svfhtermino"></vs-list-item>
                            </vs-list>
                            <!-- <vs-list>
                                <vs-list-item title="Fecha y hora de conclusión:"
                                    :subtitle="this.detalleReporteData.svfhconclusion"></vs-list-item>
                            </vs-list> -->
                        </v-card-text>
                    </v-card>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 sm12 md12>
                <v-card style="background-color:transparent !important;" width="100%">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Observaciones</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon :color="'#FFFFFF'">mdi-notebook</v-icon>
                        </v-card-title>
                        <v-card-text v-if="mostrarmov">
                            <div class="table-responsive">
                                <template v-if="agragarObs">
                                    <v-btn color="primary" class="ma-2" dark @click="dialogo = true">
                                        Agregar Movimientos </v-btn>
                                </template>
                                <table :id="tableName" class="table table-hover display responsive no-wrap" width="100%"
                                    v-if="this.observaciones">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th v-for="encabezado in headers" :key="encabezado.id">
                                                {{ encabezado.text }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="movimiento in movimientos" :key="movimiento.id">
                                            <td></td>
                                            <td>{{ movimiento.segfhalta }}</td>
                                            <td>{{ movimiento.segobs }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </v-card-text>
                        <v-card-text v-else>
                            <div class="text-center">
                                <v-progress-circular :size="70" :width="7" color="primary"
                                    indeterminate></v-progress-circular>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogo" width="500" persistent>
            <v-card>
                <v-card-title class="justify-center primary">
                    <v-toolbar-title id="titulocard">Agregar Movimiento</v-toolbar-title>
                </v-card-title>
                <v-card-text>
                    <span style="text-align: center;color: black;font-weight: bold;" class="mt-1">Observaciones:</span>
                    <v-form ref="form" v-model="valid" lazy-validation class="mt-1">
                        <v-textarea :counter="1000" maxlength="1000" :rules="rulestextarea" outlined v-model="comentarios"
                            name="input-7-4"></v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions style="justify-content: center; align-content: center;">
                    <v-btn @click="guardarMoviminto()" color="#536DFE" class="ma-2" :disabled="bloquear" style="color:white"
                        type="submit">Guardar</v-btn>
                    <v-btn @click="limpiarCampos()" color="default" class="ma-2" :disabled="bloquear">Limpiar</v-btn>
                    <v-btn @click="dialogo = false, limpiarCampos()" color="secondary" class="ma-2"
                        :disabled="bloquear">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Reporte from '@/services/reporteVial/ReporteVial.service.js';
import Telefonos from '@/components/pages/telefonos/Telefonos.vue'

import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import "datatables.net-responsive-dt";
import "datatables.net-responsive-dt/css/responsive.dataTables.min.css";


export default {
    components: {
        Telefonos
    },
    data: function () {
        return {
            showcargando: true,
            detalleReporteData: [],
            movimientos: [],
            headers: [
                { text: 'Fecha', value: 'segfhalta', class: "text title", width: "100" },
                { text: 'Observaciones', value: 'segobs', class: "text title", width: "100" },
            ],
            dialogo: false,
            comentarios: null,
            valid: true,
            agragarObs: false,
            bloquear: false,
            prefix: "tabla_",
            randomNum: Math.floor(Math.random() * 1000),
            validacionmin: null,
            valmin: false,
            rulestextarea: [v => !!v || 'Campo requerido',
            v => {
                if (v == null) {
                    return true
                }
                else {
                    // return 'Mínimo 12 Carácteres'
                    if (v.trim().length < 12) {
                        return 'Debe tener al menos 12 caracteres'
                    } else
                        return true
                }
            },
            ],
            mostrarmov: false,
            observaciones: false,
        };
    },

    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        },
        tableName() {
            return this.prefix + this.randomNum;
        },
    },
    async mounted() {
        this.showcargando = true
        this.DatosDetalle();

    },
    watch: {
        async "comentarios"(val) {
            if (val != null) {
                this.comentarios = val.trim()
                if (val.length == 0) {
                    this.comentarios = null
                }
            }
        },
    },
    methods: {
        async DatosDetalle() {
            let auxDetalleReporte = await Reporte.DetalleGeneral(this);
            for (const [key, value] of Object.entries(auxDetalleReporte)) {
                if (typeof value == "object") { auxDetalleReporte[key] = "" } else { auxDetalleReporte[key] = value.toString() }
            }
            this.detalleReporteData = auxDetalleReporte;

            let response = await Reporte.MostrarAgregar(this, this.detalleReporteData.svfhtermino);
            this.agragarObs = response.agragarObs;
            this.observaciones = response.observaciones;
            if (this.observaciones) {
                await this.Movimientos();
            } else {
                this.mostrarmov = true;
            }
            this.showcargando = false;
        },
        async Movimientos() {
            this.mostrarmov = false;
            $("#" + this.tableName + "_paginate").empty();
            $("#" + this.tableName + "_info").remove();
            $("#" + this.tableName + "_filter").remove();
            $("#" + this.tableName + "_length").remove();
            this.randomNum = Math.floor(Math.random() * 1000);
            let auxMovimientosReporte = await Reporte.Movimientos(this);
            for (let i in auxMovimientosReporte) {
                for (const [key, value] of Object.entries(auxMovimientosReporte[i])) {
                    if (typeof value == "object") { auxMovimientosReporte[i][key] = "" } else { auxMovimientosReporte[i][key] = value.toString() }
                }
            }
            setTimeout(() => {
                $(`#${this.tableName}`).DataTable({
                    dom: "iftlp",
                    lengthMenu: [
                        [20, 50, 100],
                        [20, 50, 100],
                    ],
                    paginate: true,
                    pageLength: 20,
                    responsive: {
                        details: {
                            type: 'column'
                        }
                    },
                    columnDefs: [{
                        className: 'dtr-control',
                        orderable: false,
                        targets: 0
                    }],
                    language: {
                        sProcessing: "Procesando...",
                        sLengthMenu: "Mostrar _MENU_ registros",
                        sZeroRecords: "No se encontraron resultados",
                        sEmptyTable: "Sin registros encontrados",
                        sInfo: "",
                        sInfoEmpty: "",
                        sInfoFiltered: "",
                        sInfoPostFix: "",
                        search: "",
                        searchPlaceholder: "Filtrar...",
                        sUrl: "",
                        sInfoThousands: ",",
                        sLoadingRecords: "Cargando...",
                        oPaginate: {
                            sFirst: "Primero",
                            sLast: "Último",
                            sNext: "&raquo;",
                            sPrevious: "&laquo;",
                        },
                        oAria: {
                            sSortAscending:
                                ": Activar para ordenar la columna de manera ascendente",
                            sSortDescending:
                                ": Activar para ordenar la columna de manera descendente",
                        },
                    },
                });
            });
            this.movimientos = auxMovimientosReporte;
            this.mostrarmov = true;
        },
        limpiarCampos() {
            this.$refs.form.reset();
            this.comentarios = null;
        },
        async guardarMoviminto() {
            if (this.$refs.form.validate()) {
                this.bloquear = true
                let resp = await Reporte.AgregarMovimiento(this, this.comentarios);
                if (resp.length == 0) {
                    this.$swal({
                        position: 'center',
                        icon: 'success',
                        title: 'Éxito',
                        text: 'Se guardó el comentario con éxito.',
                        showConfirmButton: true,
                        timer: 3000
                    })
                    this.limpiarCampos()
                    this.dialogo = false;
                    this.bloquear = false;
                    this.Movimientos();
                } else {
                    this.$swal({
                        position: 'center',
                        icon: 'error',
                        title: 'Ocurrió un error, inténtelo más tarde.',
                        showConfirmButton: true,
                    });
                }
            }
        },
        uppercase() {
            if (this.comentarios != '' && this.comentarios != null) {
                this.comentarios = this.comentarios.toUpperCase();
            }

        },
    },



};
</script>

<style scoped>
#DatosGenerales .vs-list--title {
    font-size: 12px;
    font-weight: 100 !important;
}

#DatosGenerales .vs-list--subtitle {
    font-size: 20px;
    font-weight: 700;
}
</style>